module.exports = __webpack_public_path__ + "img/ic_arrow_down.0b464a59.svg";